export function formatDurationFromMinutes(minutes) {
  if (minutes == null) return "-";
  const totalMinutes = Math.max(0, Math.round(Number(minutes)));
  if (!Number.isFinite(totalMinutes)) return "-";

  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const mins = totalMinutes % 60;
  const parts = [];

  if (days > 0) parts.push(`${days} ${days === 1 ? "day" : "days"}`);
  if (hours > 0) parts.push(`${hours} ${hours === 1 ? "hour" : "hours"}`);
  if (mins > 0 || parts.length === 0) parts.push(`${mins} min`);

  return parts.join(" ");
}

export function formatMemberSince(ts) {
  if (!ts) return "Member since -";
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return "Member since -";
  return `Member since ${d.toLocaleDateString(undefined, { month: "long", year: "numeric" })}`;
}

export function formatLastActive(ts) {
  if (!ts) return "Last active: -";
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return "Last active: -";
  return `Last active: ${d.toLocaleString()}`;
}

export function buildShopTrustSummary(shop) {
  return [
    `Completed work orders: ${Number(shop?.completed_work_orders_count || 0)}`,
    `Avg response: ${formatDurationFromMinutes(shop?.avg_first_response_minutes)}`,
    formatLastActive(shop?.last_active_at),
  ].join(" • ");
}
